import { ILayout, IMultimedia, IScroll, IVideo, IPdfViewer, ISlide, ISlideData } from './../interfaces/presentation-mode-status.interface';
import { ILayaoutResponse, IMultimediaResponse, IPdfViewerResponse, IPresentationModeStatusResponse, IScrollResponse, ISelectedObjectResponse, IShareTaskResponse, ISizeResponse, ISlideDataResponse, ISlideResponse, IVideoResponse } from '../interfaces/presentation-mode-status-response.interface';
import { IPresentationModeStatus, ISelectedObject, IShareTask, ITeacherSize } from '../interfaces/presentation-mode-status.interface';

export const PresentationModeStatusMapper = (data:IPresentationModeStatusResponse):IPresentationModeStatus => {    
    return {
        version         : data.vr,
        id              : data.id,
        meetingType     : data.mt,
        readOnly        : data.ro,
        transparency    : data.tr,
        zoom            : data.zm,
        selectedObject  : SelectedObjectMapper(data.so),
        shareTask       : ShareTaskMapper(data.st),
        card            : data.cd,
        slide           : SlideMapper(data.sl),
        audio           : MultimediaMaper(data.au),
        video           : VideoMaper(data.vd),
        multimediaVideo : MultimediaMaper(data.mv),
        size            : TeacherSizeMaper(data.sz),
        scroll          : ScrollMaper(data.sc),
        layout          : LayoutMaper(data.ly)
    }
}

const PdfViewerMapper = (data:IPdfViewerResponse):IPdfViewer => {
    let pdfViewer = null;
    if(data)
     pdfViewer = {
            scrollTop : data.s, 
            elementIndex : data.e, 
            type : data.t
        }
    return pdfViewer;
}

const SelectedObjectMapper = (data:ISelectedObjectResponse):ISelectedObject => {
    let selectedObject = null;
    if(data)
        selectedObject = {
            sectionId: data.id,
            materialId: data.mi,
            courseId: data.co,
            classId: data.cl,
            title: data.tl
        };
    return selectedObject;
}

const ShareTaskMapper = (data:IShareTaskResponse):IShareTask => {
    let shareTask = null;
    if(data)
        shareTask = {
            userId: data.ui,
            isTeacher: data.it,
            fullName: data.fn,
            active: data.ac,
            boardGroupHash: data.bh,
            numberPages: data.np,
            homeworkId: data.hi
        };
    return shareTask;
}

const TeacherSizeMaper = (data:ISizeResponse):ITeacherSize => {
    let size: ITeacherSize = null;
    if(data)
     size = { 
            teacherWidth: data.w,
            teacherHeight: data.h
        };
    return size;
}

const MultimediaMaper = (data:IMultimediaResponse):IMultimedia => {
    let multimedia : IMultimedia = null;
    if(data)
        multimedia = {
        currentTime : data.ct,
        eventType : data.et,
        isPaused : data.ip,
        isMuted : data.im,
        volume : data.vl,
     }
    return multimedia;
}

const VideoMaper = (data:IVideoResponse):IVideo => {
    let video : IVideo = null;
    if(data)
        video = {
            currentTime : data.ct,
            type : data.ty,
            isPaused : data.ip,
            isMuted : data.im,
            volume : data.vl,
        }
    return video;
}

const LayoutMaper = (data:ILayaoutResponse):ILayout => {
    let layaout : ILayout = null;
    if(data)
        layaout = {
            layout: data.l,
            tab: data.t
        }
    return layaout;
}

const ScrollMaper = (data:IScrollResponse):IScroll => {
    let scroll : IScroll = null;
    if(data){
        let pdfViewer0 : IPdfViewer = PdfViewerMapper(data.p0);
        let pdfViewer1 : IPdfViewer = PdfViewerMapper(data.p1);
        scroll = {
            pdfViewer0 : pdfViewer0,
            pdfViewer1 : pdfViewer1,
        }
    }
    return scroll;
}
const SlideMapper = (data:ISlideResponse):ISlide => {
    let slide : ISlide = null;
    if(data)
        slide = {
            data : SlideDataMapper(data.dt),
            type : data.tp
        }
    return slide;
}

const SlideDataMapper = (data:ISlideDataResponse):ISlideData => {
    let slideData : ISlideData = null;
    if(data)
        slideData = {
            currentTime : data.t,
            eventType : data.e,
            slide : data.s
        }
    
    return slideData;
}




